import BigPicture from 'bigpicture';
import hljs from 'highlight.js/lib/core';
import javascript from 'highlight.js/lib/languages/javascript';
import xml from 'highlight.js/lib/languages/xml';
import Typed from 'typed.js';

// Configure highlight.js
hljs.registerLanguage('xml', xml);
hljs.registerLanguage('javascript', javascript);

window.BigPicture = BigPicture;
window.hljs = hljs;
window.Typed = Typed;
